import React, { Component } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import './assets/css/bulma.min.css';
import 'react-quill/dist/quill.snow.css';
import 'moment/locale/es';
import './assets/css/styles.min.css';

export default class AppContainer extends Component {
	render() {
		return (<div>
			{React.cloneElement(this.props.children, this.props)}
		</div>);
	}
}


// WEBPACK FOOTER //
// ./src/app.js